export class AreaUbiquityModel {
    public cm_riferimento:any;
    public notes:string;
}